
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvTableFieldArray } from "bootstrap-vue";
import { i18n } from "@/i18n";
import { IClientExtradata } from "@/entities";
import IconTrash from "@/components/common/icon/IconTrash.vue";
import IconEdit from "@/components/common/icon/IconEdit.vue";
import AddEditExtradataModal from "@/components/client/AddEditExtradataModal.vue";

@Component({
  name: "extradata-table",
  components: {
    IconEdit,
    AddEditExtradataModal,
    IconTrash,
  },
})
export default class ExtradataTable extends Vue {
  @Prop({ required: false, default: null }) extradataList!: IClientExtradata[];
  private extradataSelected: IClientExtradata | null = null;
  public collapsed = true;

  constructor() {
    super();
  }

  get fields(): BvTableFieldArray {
    return [
      {
        key: "actions-left",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-first align-middle",
      },
      {
        key: "name",
        label: i18n.t("label.name") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "label",
        label: i18n.t("label.label") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "type",
        label: i18n.t("label.type") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        formatter: (value?: string) => {
          return this.$te(`label.${value}`) ? this.$t(`label.${value}`) : value;
        },
      },
      {
        key: "attr1",
        label: i18n.t("label.others") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-last align-middle",
      },
    ];
  }

  removeExtradata(index: number): void {
    this.extradataList.splice(index, 1);
  }

  openNewExtradataModal(): void {
    this.extradataSelected = null;
    this.$nextTick(() => this.$bvModal.show("addEditExtradataModal"));
  }
  editExtradata(extradata: IClientExtradata): void {
    this.extradataSelected = extradata;
    this.$nextTick(() => this.$bvModal.show("addEditExtradataModal"));
  }
}
